exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1swFjiaVkGUumjcM5Z5SFb{display:inline;width:70%}html[dir=ltr] ._1swFjiaVkGUumjcM5Z5SFb{float:left}html[dir=rtl] ._1swFjiaVkGUumjcM5Z5SFb{float:right}._1uUgob4fSinINkPp1o1SlX{display:inline}html[dir=ltr] ._1uUgob4fSinINkPp1o1SlX{float:right}html[dir=rtl] ._1uUgob4fSinINkPp1o1SlX{float:left}", ""]);

// exports
exports.locals = {
	"subscription_text_container": "_1swFjiaVkGUumjcM5Z5SFb",
	"subscription_btn_container": "_1uUgob4fSinINkPp1o1SlX"
};